// Federation subject matching. A registered subject is either an exact string
// or a trailing-`*` glob (e.g. `repo:tines/3B:*` to match any branch). The glob
// is deliberately constrained: `*` may appear only as the final character, and
// the character before it must be a boundary (`:` or `/`). This prevents an
// over-broad prefix from matching a sibling identity — e.g. `repo:tines/3B*`
// would match `repo:tines/3B-evil:...`, so it is rejected; `repo:tines/3B:*`
// only matches subjects under that exact repo.

const BOUNDARY_CHARS = new Set([":", "/"]);

export function isValidSubjectPattern(pattern: string): boolean {
  const star = pattern.indexOf("*");
  if (star === -1) return pattern.length > 0; // exact subject
  // Exactly one `*`, and it must be the final character.
  if (star !== pattern.length - 1) return false;
  // Need a real prefix and a boundary char immediately before the `*`.
  if (star === 0) return false; // bare `*`
  return BOUNDARY_CHARS.has(pattern[star - 1]!);
}

// Whether a registered `pattern` matches a token's `sub` claim.
export function subjectMatches(pattern: string, sub: string): boolean {
  if (!pattern.endsWith("*")) return pattern === sub;
  const prefix = pattern.slice(0, -1);
  return sub.startsWith(prefix);
}
